export const formatCurrency = (value) => {
  if (!value || isNaN(value)) return "";
  const numValue = typeof value === "string" ? parseFloat(value) : value;
  return `$${Math.round(numValue).toLocaleString()}`;
};

export const formatPercentage = (value) => {
  if (!value) return "";
  // Handle if value is already a percentage string
  if (typeof value === "string" && value.includes("%")) {
    return `${parseInt(value.replace("%", ""), 10)}%`;
  }

  // Handle numeric values
  const numValue = typeof value === "string" ? parseFloat(value) : value;
  if (isNaN(numValue)) return "";
  return `${Math.round(numValue)}%`;
};

export const formatDecimal = (value, decimals = 2) => {
  if (!value || isNaN(value)) return "";
  const numValue = typeof value === "string" ? parseFloat(value) : value;
  return `$${numValue.toFixed(decimals).toLocaleString()}`;
};

export const formatDate = (value) => {
  if (!value) return "";
  const date = new Date(value);
  return !isNaN(date.getTime()) ? date.toLocaleDateString() : "";
};

// Utility to normalize facility names across datasets
export const normalizeFacilityName = (name) => {
  if (!name) return "";
  return name
    .trim()
    .toLowerCase()
    .replace(/\s+/g, " ") // Replace multiple spaces with single space
    .replace(/[^\w\s-]/g, ""); // Remove special characters except spaces and hyphens
};

// Utility to check if two facility names are equivalent
export const areFacilityNamesEquivalent = (name1, name2) => {
  return normalizeFacilityName(name1) === normalizeFacilityName(name2);
};

// Enhanced utility to match facility names that may be shortened or abbreviated
// Handles cases like "Bainbridge" matching "BAINBRIDGE HEALTH AND REHAB"
export const facilitiesMatchFlexible = (shortName, fullName) => {
  if (!shortName || !fullName) return false;

  // First try exact match
  if (areFacilityNamesEquivalent(shortName, fullName)) return true;

  // Normalize both names
  const normalizedShort = normalizeFacilityName(shortName);
  const normalizedFull = normalizeFacilityName(fullName);

  // Check if the shorter name is contained in the longer name
  // This handles "bainbridge" being in "bainbridge health and rehab"
  if (normalizedFull.includes(normalizedShort)) return true;
  if (normalizedShort.includes(normalizedFull)) return true;

  // Check if all words from the shorter name appear in the longer name
  const shortWords = normalizedShort.split(" ").filter((w) => w.length > 2);
  const fullWords = normalizedFull.split(" ");
  if (
    shortWords.length > 0 &&
    shortWords.every((word) => fullWords.includes(word))
  ) {
    return true;
  }

  return false;
};
